import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';

export type DeputecEmploymentContractLeaveRule = {
  Id: number;
  ContractId: number;
  LeaveRuleId: number;
  BasePayRule: number;
  LoadingPayRule1?: string;
  LoadingPayRule2?: string;
  LoadingPayRule3?: string;
  Creator: number;
  Created: string;
  Modified: string;
  LeaveRule: {
    Id: number;
    Name: string;
    Type: string;
    Description: string;
    MaxAllowedAnnually: number;
    PaidLeave: boolean;
    AnnualRollOver: boolean;
    Visible: boolean;
    UnitType?: string;
    ResetType?: string;
    ResetSchedule?: string;
    ResetValue?: string;
    PayoutOnTermination: boolean;
    EntitlementAfterMonth: number;
    ExportType: number;
    PayrollCategory: string;
    CalcType: number;
    Calc?: string;
    F00?: string;
    F01?: string;
    F02?: string;
    F03?: string;
    F04?: string;
    F05?: string;
    F06?: string;
    F07?: string;
    F08?: string;
    F09?: string;
    Creator: number;
    Created: string;
    Modified: string;
  };
  BasePayRuleObject: {
    Id: number;
    PayTitle: string;
    RemunerationType: number;
    RemunerationBy: number;
    AnnualSalary?: string;
    HourlyRate: number;
    IsMultiplier: boolean;
    MultiplierValue?: string;
    MultiplierBaseRate?: string;
    MinimumType: number;
    MaximumType: number;
    MinimumValue?: string;
    MaximumValue?: string;
    MinimumShiftLength?: string;
    MaximumShiftLength?: string;
    AdvancedCalculation?: string;
    IsExported: boolean;
    UnitValue?: string;
    Schedule: number;
    RecommendWith: number;
    DexmlScript?: string;
    DexmlScriptParam?: string;
    PeriodType?: string;
    PayPortionRule: number;
    PayrollCategory?: string;
    Comment: string;
    Creator: number;
    Created: string;
    Modified: string;
  };
};

export type DeputecPayRule = {
  Id: number;
  PayTitle: string;
  RemunerationType: number;
  RemunerationBy: number;
  AnnualSalary?: string;
  HourlyRate: number;
  IsMultiplier: boolean;
  MultiplierValue?: string;
  MultiplierBaseRate?: string;
  MinimumType: number;
  MaximumType: number;
  MinimumValue?: string;
  MaximumValue?: string;
  MinimumShiftLength?: string;
  MaximumShiftLength?: string;
  AdvancedCalculation?: string;
  IsExported: boolean;
  UnitValue?: string;
  Schedule: number;
  RecommendWith: number;
  DexmlScript?: string;
  DexmlScriptParam?: string;
  PeriodType?: string;
  PayPortionRule: number;
  PayrollCategory?: string;
  Comment: string;
  Creator: number;
  Created: string;
  Modified: string;
  ScheduleObject: {
    Id: number;
    Name: string;
    StartDate: string;
    StartTime: string;
    EndTime: string;
    RepeatType: number;
    RepeatEvery: number;
    WeeklyOnDays: string;
    MonthlyOnDates?: string;
    MonthlyOnDays?: string;
    EndDate?: string;
    Exception?: string;
    Saved: boolean;
    Orm?: string;
    Template: boolean;
    Creator: number;
    Created: string;
    Modified: string;
  };
};

export type LibraryTemplateGetResponse = {
  success: boolean;
  message: string;
  data: {
    DeputecEmploymentContractLeaveRules: DeputecEmploymentContractLeaveRule[];
    DeputecPayRules: DeputecPayRule[];
    IsSalaryContract: boolean;
  };
};

type LibraryTemplateGetParams = {
  intTemplateEmploymentTermImplementationId?: number;
  strTemplateEmploymentTermCountryFolder?: string;
  strTemplateEmploymentTermFileName?: string;
};

export default async function libraryTemplateGet({
  awardId,
  newAwardId,
}: {
  awardId?: number;
  newAwardId?: string;
}): Promise<LibraryTemplateGetResponse> {
  if (awardId !== 0 && !awardId && !newAwardId) {
    throw new Error(
      'Invalid arguments to get template info awardId or newAwardId is required'
    );
  }

  try {
    const objParam: LibraryTemplateGetParams = {};

    if (awardId || awardId === 0) {
      objParam.intTemplateEmploymentTermImplementationId = awardId;
    } else if (newAwardId) {
      const [countryFolder, fileName] = newAwardId.split('/');
      objParam.strTemplateEmploymentTermCountryFolder = countryFolder;
      objParam.strTemplateEmploymentTermFileName = fileName;
    }

    if (Object.keys(objParam).length === 0) {
      throw new Error(
        'Invalid body payload generated for GetTeamTemplateTermInfo'
      );
    }

    const result = await mushodoPromise<
      LibraryTemplateGetResponse & {
        error: string;
      }
    >('GetTeamTemplateTermInfo', objParam);

    if (result.error) {
      throw result.error;
    }

    return {
      success: true,
      message: '',
      data: (result as unknown) as LibraryTemplateGetResponse['data'],
    };
  } catch (e) {
    throw e;
  }
}
